import React, { useEffect, useState } from "react";
import LoyaltyCardDefaultDisplay from "./LoyaltyCardDefaultDisplay";
import type {
  LoyaltyCardProps,
  LoyaltyCardPresentationProps,
} from "../../types/LoyaltyCardTypes";

export type {
  LoyaltyProgramType,
  LoyaltyCardTemplate,
  LoyaltyCardProps,
  LoyaltyCardPresentationProps,
} from "../../types/LoyaltyCardTypes";

const LoyaltyCardRenderer: React.FC<LoyaltyCardProps> = ({
  customerIdentification = "",
  entityIdentification = "",
  entity,
  program,
  member,
  qr,
  shareUrl,
  rewardPath,
  googleReview,
  widget,
  hideAuth = false,
}) => {
  const [reviewUrl, setReviewUrl] = useState("");

  useEffect(() => {
    if (googleReview?.enabled && googleReview?.place_id !== "") {
      setReviewUrl(
        `https://search.google.com/local/writereview?placeid=${googleReview?.place_id}`
      );
    }
  }, [googleReview]);

  const presentationProps: LoyaltyCardPresentationProps = {
    entityIdentification,
    customerIdentification,
    entity,
    program,
    member,
    qr,
    shareUrl,
    rewardPath,
    googleReview: {
      enabled: googleReview?.enabled || false,
      url: reviewUrl || "",
    },
    widget,
    hideAuth,
  };

  return <LoyaltyCardDefaultDisplay {...presentationProps} />;
};

export default LoyaltyCardRenderer;
